import { Flex, Layout, Menu, type MenuProps } from 'antd';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

import IconArrowRight from '@/assets/icons/arrow-right.svg?react';
import IconSiderArrow from '@/assets/icons/sider-arrow.svg?react';
import { SIDER_CONTENTS } from '@/constants/sider.constants';
import { useUserInformation } from '@/hooks/use-user-information';

type MenuItem = Required<MenuProps>['items'][number];

export function Sider() {
  const { role } = useUserInformation();

  function filterByRoles({
    roles,
  }: (typeof SIDER_CONTENTS)[number]['routes'][number]) {
    return !roles || roles?.includes(role!);
  }

  const menuItems: MenuItem[] = SIDER_CONTENTS.filter(
    ({ routes }) => routes.filter(filterByRoles)?.length > 0,
  ).map(({ group, routes }, index) => ({
    key: index,
    label: (
      <Flex align="center">
        <IconSiderArrow className="mr-4" />
        {group}
      </Flex>
    ),
    type: 'group',
    children: routes.filter(filterByRoles).map(({ path, name }) => ({
      key: path,
      title: name,
      label: (
        <NavLink
          to={path}
          className={({ isActive }) =>
            classNames('nav-link', { active: isActive })
          }
        >
          {name}
        </NavLink>
      ),
    })),
  }));

  return (
    <Layout.Sider
      collapsible
      width={280}
      collapsedWidth={20}
      breakpoint="md"
      trigger={<IconArrowRight />}
    >
      <Menu mode="inline" items={menuItems} inlineIndent={0} />
    </Layout.Sider>
  );
}
